import dayjs from 'dayjs'

export const NEWS_APP_CODE = 'KLSW'

export const NEWS_LEGACY_TYPE_MAP = {
  19101: 1,
  19102: 2,
  19103: 3,
  19104: 4,
}

export const NEWS_LEGACY_PATH_MAP = {
  '/news/industry': '全球前沿资讯',
  '/news/stipulate': '行业新规',
  '/news/enterprise': '企业动态',
  '/news/staff': '员工风采',
}

export function normalizeNewsCategory(item = {}) {
  return {
    id: item.id ?? item.category_id ?? item.categoryId ?? '',
    name: item.name || item.category_name || item.categoryName || '',
    appCode: item.app_code || item.appCode || '',
  }
}

export function normalizeNewsItem(item = {}) {
  const pbctnDate = item.pbctn_date || item.pbctnDate || ''

  return {
    ...item,
    id: item.id ?? '',
    title: item.title || '',
    subTitle: item.sub_title || item.subTitle || '',
    headPic: item.head_pic || item.headPic || '',
    pbctnDate,
    categoryId: item.category_id ?? item.categoryId ?? '',
    categoryName: item.category_name || item.categoryName || '',
    appCode: item.app_code || item.appCode || '',
    appName: item.app_name || item.appName || '',
    content: item.content || '',
  }
}

export function normalizeNewsListItem(item = {}) {
  const newsItem = normalizeNewsItem(item)
  const date = newsItem.pbctnDate ? dayjs(newsItem.pbctnDate) : null

  return {
    ...newsItem,
    day: date ? date.format('DD') : '',
    month: date ? date.format('YYYY-MM') : '',
    time: date ? date.format('YYYY/MM/DD') : '',
  }
}
